let createActionName = require('../util').createActionName('toasts');

export const PUSH_TOAST = createActionName('PUSH_TOAST');
export const REMOVE_TOAST = createActionName('REMOVE_TOAST');

export const pushToast = (toast) => ({
  type: PUSH_TOAST,
  payload: { toast },
});

export const removeToast = (key) => ({
  type: REMOVE_TOAST,
  payload: { key },
});

/**
 * Since all toasts are shown as alerts,
 * the removal is always done on the component
 * whether it is by timeout or click.
 *
 * @param toast
 * @returns {Function}
 */
export const doPushToast = (toast) => (dispatch) => {
  dispatch(pushToast(toast));
};
